import bootbox from 'bootbox'

// Fonction ne notification des utilisateurs
export default function Notify(message, type){
  var prefix = '';
  if (type != null){
    prefix = `<div class="modal-icon modal-icon-${type}"><i class="zmdi zmdi-exclamtion"></i></div>`;
  }
  bootbox.alert({
    message: prefix+message,
    className: 'bb-alternate-modal'
  })
}